import { LockIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

import {
  AddPaymentMethodImmediateBenefits,
  AddPaymentMethodProBenefits,
} from './add-payment-method-benefits.atom'

export interface AddPaymentMethodContentProps {
  onAddCard: () => void
  isLoading?: boolean
  companyName?: string
  onCompanyNameChange?: (value: string) => void
  className?: string
}

export const AddPaymentMethodContent: React.FC<AddPaymentMethodContentProps> = ({
  onAddCard,
  isLoading = false,
  companyName = '',
  onCompanyNameChange,
  className,
}): ReactNode => (
  <ScrollArea className={cn('add-payment-method-content h-full', className)}>
    <div className="flex flex-col gap-6 p-6">
      <div className="flex flex-col gap-1">
        <h2 className="text-xl font-semibold">Add Payment Method</h2>
        <p className="text-sm text-muted-foreground">
          Add a card to unlock premium features. We won&apos;t charge you anything.
        </p>
      </div>

      <AddPaymentMethodImmediateBenefits />

      <Separator />

      <div className="flex flex-col gap-2">
        <Label htmlFor="company-name" className="text-sm">
          Company Name <span className="text-muted-foreground">(optional)</span>
        </Label>
        <Input
          id="company-name"
          placeholder="Enter your company name"
          value={companyName}
          onChange={(e) => onCompanyNameChange?.(e.target.value)}
          className="add-payment-company-input"
        />
      </div>

      <Button
        onClick={onAddCard}
        disabled={isLoading}
        size="lg"
        className="add-payment-method-button w-full"
      >
        {isLoading ? 'Redirecting...' : 'Add Payment Method'}
      </Button>

      <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
        <LockIcon className="size-3" />
        <span>Secure payment</span>
      </div>

      <Separator />

      <AddPaymentMethodProBenefits />
    </div>
  </ScrollArea>
)
